import ApiService from '../../utils/fetch';
const outboundShipmentUrl = `${process.env.REACT_APP_BASE_URL}demand/shipments/`;

export const fetchHeaderAndLinesData = async (shipmentNo) => {
    const response = await ApiService.get(`${outboundShipmentUrl}${shipmentNo}`);
    return response.data;
};

export const fetchDeliveryData = async (shipmentNo) => {
    const response = await ApiService.get(`${outboundShipmentUrl}${shipmentNo}/delivery`);
    return response.data;
}

export const fetchItemsData = async (shipmentNo) => {
    const response = await ApiService.get(`${outboundShipmentUrl}${shipmentNo}/item`);
    return response.data;
}

export const fetchOrdersData = async (shipmentNo) => {
    const response = await ApiService.get(`${outboundShipmentUrl}${shipmentNo}/order`);
    return response.data;
}

